import React, { useContext, useEffect, useState } from 'react';
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
} from 'reactstrap';

import { color } from '~/assets/styles/colors';
import { LoaderMini } from '~/components/Loaders';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Text } from '../../../components/Text';
import { CardFilial } from '../../../components/CardFilial';

import { symbolPriceFormatter } from '../../../helpers/price';
import { PedidoContext } from '../../../context/PedidoContext';
import { FilialContext } from '../../../context/FilialContext';
import { DivMontante, TextMontante, ImgMontante } from './styles';
import money from '../../../assets/img/money.svg';

export default function Filial(props) {
	const { user, isMobile } = props;

	const {
		loadingResumo,
	} = useContext(PedidoContext);

	const { getFiliais, dataFiliais, montante, totalFilial, loadingFilial } = useContext(FilialContext);
	const [expanded, setExpanded] = React.useState(false);
	const [pagina, setPagina] = useState(1);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	useEffect(() => {
		getFiliais(user.dados.documento, pagina);
	}, [pagina]);

	const RowCred = (
		<Col sm="12" md="8" lg="9">
			<>
				<Text style={{ margin: '0 0 0 0' }}>CRÉDITO POR FILIAIS</Text>
				<CardFilial
					dataFiliais={dataFiliais}
					isMobile={isMobile}
					totalFilial={totalFilial}
					user={user}
					loadingResumo={loadingResumo}
					pagina={pagina}
					setPagina={setPagina}
				/>
			</>
		</Col>
	)
	return (
		<Container fluid>
			{loadingFilial ?
				<>
					{isMobile ?
						<Accordion style={{ margin: '20px 0 20px 0', backgroundColor: color.greenLight }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1bh-content"
								id="panel1bh-header"
								style={{ backgroundColor: color.primary }}
							>
								<Typography sx={{ width: '100%', flexShrink: 0 }}>
									{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && <Text>Cred. Revenda</Text>}
									{user.dados.cargo.toLowerCase() === 'industria' && <Text>Cred. Distribuidor</Text>}
								</Typography>
							</AccordionSummary>
							<Row style={{ padding: '10px' }}>{RowCred}</Row>
						</Accordion>
						:
						<Row style={{ padding: '10px' }}>
							{RowCred}
							<Col sm="12" md="4" lg="3">
								{user.dados.permissoes.view_credito_revenda ?
									<>
										<Text style={{ textAlign: 'right' }}>
											Montante de Crédito
										</Text>
										<Card
											style={{
												marginBottom: 0,
												backgroundColor: color.secondary,
												borderTopRightRadius: 10,
												borderBottomLeftRadius: 10,
												borderBottomRightRadius: 10,
											}}>
											<CardBody className="py-4 px-2">
												<DivMontante>
													{!montante ? (
														<LoaderMini />
													) : (
														<>
															<TextMontante
																style={{ marginRight: '5%' }}>
																<Text
																	color="softBlack"
																	size="big">
																	{symbolPriceFormatter(montante)}
																</Text>
																{/* } */}
															</TextMontante>
															<ImgMontante
																alt="money"
																width="20"
																src={money}
															/>
														</>
													)}
												</DivMontante>
											</CardBody>
										</Card>
									</> : <></>}
							</Col>
						</Row>
					}
				</>
				:
				<LoaderMini />}
		</Container>
	);
}
